import { render, staticRenderFns } from "./Revezamento.vue?vue&type=template&id=5a412f5c&"
import script from "./Revezamento.vue?vue&type=script&lang=js&"
export * from "./Revezamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports